import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme, alpha } from "@mui/material";


export default function CardMarker(props) {

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { headline, subtext, list, add, info, addtextright, cardlines, glass } = props

return(

<Card variant="outlined" sx={{  width: '100%',
                                maxWidth: {xs: 400, sm: 640, md: 640, lg: 780, xl: 780},
                                height: {xs: 'auto', sm: 'auto', md: 'auto', lg: 'auto', xl: 'auto'},
                                borderRadius: glass ? "28px" : 4,

                                mx: {xs: 2, sm: 4},
                                my: 4,
                                p:1,

                                ...(glass ? {
                                  bgcolor: isDark ? alpha("#fff", 0.04) : alpha("#fff", 0.5),
                                  backdropFilter: "blur(28px) saturate(180%)",
                                  WebkitBackdropFilter: "blur(28px) saturate(180%)",
                                  borderColor: isDark ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.65)",
                                  boxShadow: isDark
                                    ? "inset 0 1px 0 rgba(255,255,255,0.06), 0 8px 32px rgba(0,0,0,0.55)"
                                    : "inset 0 1px 0 rgba(255,255,255,0.7), 0 4px 24px rgba(0,0,0,0.06)",
                                } : {
                                  bgcolor: theme.palette.mode === "light" ? 'grey.C50' : 'greydark.C970',
                                  borderColor: theme.palette.mode === "light" ? 'grey.C900' : 'greydark.C400',
                                }),
                                 }}>
  <CardContent>

      <Grid container>   
     
            <Grid size={12}> <Typography variant="h5" fontWeight={500} textAlign='left' gutterBottom color={isDark ? "grey.C50" : "greydark.C900"} sx={{ letterSpacing: "-0.015em" }}> {headline} </Typography>  </Grid>
            <Grid size={12}> <Typography variant="subtitle1" color="text.secondary" textAlign='left' gutterBottom>{subtext} </Typography>  </Grid>
            <Grid size={5} sx={{mb:2, display:'flex', justifyContent:'left' }}><Stack direction="row"> {list} {add} {info} </Stack></Grid>
            <Grid size={6} sx={{m:1, display:'flex', justifyContent:'right', alignItems: 'center' }}>{addtextright} </Grid>
            <Grid size={12}>{ cardlines }</Grid>  

     </Grid>        

  </CardContent>

</Card>

)
}

